import { Container, Row, Col, Modal } from 'react-bootstrap';
import Button from '../../../components/Button';

export type ReportEventModalProps = React.PropsWithChildren<{
  showRetireOnlineReviewModal: boolean;
  editPreviousStep?: () => void;
  handleCloseRetireOnlineReviewModal: () => void;
}>;

const RetireOnlineReviewModal = ({
  showRetireOnlineReviewModal,
  editPreviousStep,
  handleCloseRetireOnlineReviewModal,
}: ReportEventModalProps) => {
  return (
    <Modal
      size={'lg'}
      show={showRetireOnlineReviewModal}
      onHide={handleCloseRetireOnlineReviewModal}
    >
      <Container className={'p-12'}>
        <Modal.Header
          className={'border-0 mx-0 pt-0 pb-12 ms-auto'}
          closeButton
        >
          <Modal.Title className={'h6 fw-normal w-100 text-center'}>
            <Row>
              <h4 className={'mb-0 text-fs-4 ms-5'}>Warning!</h4>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Row className='justify-content-center'>
          <Col className="d-flex justify-content-center col-10 col-sm-10 col-lg-9">
            <img className="img-fluid w-50" src={`${process.env.PUBLIC_URL}/${'alarm.png'}`} alt="alarm" />
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-center my-11 pt-5">
            <p className="m-0 fw-light text-fs-6 px-lg-13 mx-sm-13 text-center lh-xs">
              Please note that any changes made here will affect all your
              previous selections
            </p>
          </Col>
        </Row>
        <Row
          className={
            'd-flex flex-column-reverse flex-lg-row justify-content-center'
          }
        >
          <Col className={'col-12 col-lg-3 '}>
            <Button
              onClick={handleCloseRetireOnlineReviewModal}
              className={'col-12 '}
              variant={'primary-outline'}
            >
              Cancel
            </Button>
          </Col>
          <Col className={'col-12 col-lg-3 mb-7 mb-lg-0'}>
            <Button className={'col-12'} onMouseDown={editPreviousStep}>
              Continue
            </Button>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export default RetireOnlineReviewModal;
